module.exports = "<agm-map  [latitude]=\"lat\"\n          [longitude]=\"lng\" [zoom]=\"16\">\n  <agm-marker  [latitude]=\"lat\"\n               [longitude]=\"lng\"></agm-marker>\n</agm-map>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/things/things-details/location-details/map.component.html
// module id = 1483
// module chunks = 0